import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { Config } from 'src/app/app-constant';
import { DatePipe } from '@angular/common';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';
import { CopypreviousmonthpopupComponent } from '../../dwm-popups/copypreviousmonthpopup/copypreviousmonthpopup.component';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { formatText } from 'src/app/shared/commen-function-file';
import { GetCompanyAndUsersData } from 'src/app/services/get-company-and-users-data/get-company-and-users-data.service';
import { DwmGenericServiceService, TableState } from '../../_DWM-Generic-Services/generic-service.service';

@Component({
  selector: 'app-my-dwm-create',
  templateUrl: './my-dwm-create.component.html',
  styleUrls: ['./my-dwm-create.component.scss']
})
export class MyDwmCreateComponent implements OnInit {
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any;
  loggedInUserEmpCode: any | null;
  loggedInUserId: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInUserRole: any;
  loggedInUserRoles: any;
  subModuleButtonColor: any | null;
  buttonColorName: any;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoleIsEmployee: any;
  fromYear: any;
  selectedYear: any;
  toYear: any;
  selectedMonth = '';
  months: string[] = [];
  pmsYears: any = [];
  showCopyButton = true;
  showAddOrSaveButton = true;
  isCurrentYearSelected: boolean = false;
  getMonthsByFiscalandReviewCycle: any = [];
  selectedYearForDWM: any = null;
  selectedMonthForDWM: string = '';
  selectedMonthYearDWM: string = 'Monthly';
  selectedTaskList: any = [];
  searchTaskString: any = null;
  selectedSizeOfTask: any = 25;
  selectAllTaskCheckbox: boolean = false;
  taskColumnHeaderInfoData: any = [];
  // ---------------- Non-R&D Pagination ----------------
  currentPageNumber = 1; // 1-based (UI friendly)
  // default page size
  totalTaskCount = 0;
  totalTaskPages = 0;

  showingCount = 0;
  showingOfCount = 0;

  pagedGroupedReportData: any[] = [];

  taskDate: any = null;
  selectAllCheckbox: boolean = false;
  frequencyListToShow: string[] = [];
  taskList: any[] = [];
  dwmData: any[] = [];
  calendarDays: number[] = [];
  toggleDownloadBtn: boolean = false;
  selectedAnnually: any = '';
  selectedMonthName: any = '';
  categoryList: any[] = [];
  loggedInUserName: any;
  today: Date = new Date();
  isRNDEmployee = false;
  isL4AndAboveEmployee = false;
  formatedataVariable = formatText;

  cuttoffDetails: { getCurrentCuttOffDate: Date | null; getCurrentCuttOffDateInMs: number | null } | null = {
    getCurrentCuttOffDate: null,
    getCurrentCuttOffDateInMs: null
  };

  constructor(
    private datePipe: DatePipe,
    public sharedService: SharedService,
    public dialogRef: MatDialogRef<MyDwmCreateComponent>,
    private encryptionService: EncryptionService,
    private httpService: HttpService,
    private config: Config,
    public router: Router,
    public dialog: MatDialog,
    private toastr: ToastrService,
    public mobileResponsiveService: MobileResponsiveService,
    public dwmGenericServiceService: DwmGenericServiceService,
    private getCompanyAndUserData: GetCompanyAndUsersData
  ) {}

  // --------------- Frequency List -----------------

  allFrequencyList: string[] = ['Hourly', 'Daily', 'Weekly', 'Fortnightly', 'Monthly', 'Quarterly', 'Semi-Annually', 'Annually'];

  annualFrequencyList: string[] = ['Monthly', 'Quarterly', 'Semi_Annually', 'Annually'];

  frequencyList: string[] = [...this.allFrequencyList];

  // --------------- Months List -----------------

  filteredMonthsList: string[] = [];

  monthsList: string[] = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  // --------------- Month Year List -----------------

  monthYear: string[] = ['Monthly', 'Annually'];

  // --------------- DWM Table Header Names -----------------

  dwmTableHeaderNames: string[] = ['Critical', 'Category', 'Actionable', 'Time From', 'Time To', 'Repeat?', 'Frequency', 'Date', 'Status', 'Manager Comment', 'Action'];

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));

    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
    if (this.loggedInUserRoles.length == 1) {
      for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
        if (this.loggedInUserRoles[i].displayName == 'Employee') {
          this.loggedInUserRoleIsEmployee = true;
        }
      }
    }

    this.dwmGenericServiceService.getDWMSetup().subscribe((res: any) => {
      this.cuttoffDetails = this.dwmGenericServiceService.checkGetDWMSetup(res);
    });

    this.getpmsyearlist();

    // const currentMonthIndex = new Date().getMonth();
    // this.selectedMonthForDWM = this.monthsList[currentMonthIndex];
    // this.checkIfPreviousMonthSelected();
  }

  // --------------- Get PMS Year List -----------------

  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);
      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;

      this.setSelectedYear(yearValue);
    });
  }

  // --------------- Set Selected Year -----------------

  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYearForDWM = selectedYearObj?.year;

      let test = selectedYearObj?.year.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];
      this.getYearSetupForDWM(this.selectedYearForDWM);
      this.defaultCallFunctionsList();
      [this.fromYear, this.toYear] = selectedYearObj.year.split('-');
    }
  }

  // --------------- Default Call Functions List -----------------

  defaultCallFunctionsList() {
    this.getEmployeeList();
    this.getDWMCatwegoryList();
    this.getNewDWMData();
  }

  // -------------- Select Year Setup -----------------

  selectYearSetup(year: any) {
    this.selectedYearForDWM = year;
    this.selectedYear = year;
    this.defaultCallFunctionsList();
  }

  // --------------- Get Year Setup For DWM -----------------

  getYearSetupForDWM(year: any) {
    this.selectedYearForDWM = year;
    this.selectedYear = year;
    const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);
    // console.log("Company Fiscal Year..", this.loggedInCompanyFiscalyear)
    const currentFiscalYear = `${fiscalStartYear}-${fiscalEndYear}`;
    // console.log("Current Fiscal Year...", currentFiscalYear)
    this.isCurrentYearSelected = year === currentFiscalYear;
    this.filterMonthsByFiscalYear(year);
    this.currentPageNumber = 1;

    this.getNewDWMData();
  }

  filterMonthsByFiscalYear(selectedYear: string) {
    const fiscal = this.loggedInCompanyFiscalyear;
    const [startMon, endMon] = fiscal.split('_');

    const monthIndex = (mon: string) => new Date(`${mon} 1, 2000`).getMonth();

    const startIdx = monthIndex(startMon);
    const endIdx = monthIndex(endMon);

    this.filteredMonthsList = startIdx <= endIdx ? this.monthsList.slice(startIdx, endIdx + 1) : [...this.monthsList.slice(startIdx), ...this.monthsList.slice(0, endIdx + 1)];

    const currentMonth = new Date().toLocaleString('default', {
      month: 'long'
    });

    this.selectedMonthForDWM = this.isCurrentYearSelected && this.filteredMonthsList.includes(currentMonth) ? currentMonth : '';
    //     if (this.isCurrentYearSelected && this.filteredMonthsList.includes(currentMonth)) {
    //   this.selectedMonthForDWM = currentMonth;
    // } else if (this.filteredMonthsList.length) {
    //   // ✅ DEFAULT TO FIRST MONTH OF FY
    //   this.selectedMonthForDWM = this.filteredMonthsList[0];
    // }
  }

  //  ------------- For current and future month -----------------------
  isCurrentOrFutureSelectedMonth(): boolean {
    if (!this.selectedMonthForDWM || !this.selectedYearForDWM) return false;

    const today = new Date();
    const currentMonthIndex = today.getMonth(); // 0 = Jan
    const currentYear = today.getFullYear();

    // Extract year from fiscal year (start year)
    const selectedYear = Number(this.selectedYearForDWM.split('-')[0]);
    const selectedMonthIndex = this.monthsList.indexOf(this.selectedMonthForDWM);

    // Show if selected year is in future
    if (selectedYear > currentYear) return true;

    // Show if selected year is current year and selected month >= current month
    if (selectedYear === currentYear && selectedMonthIndex >= currentMonthIndex) return true;

    return false; // All previous months
  }


  // disabled the add new

  

  // --------------- Check If Previous Month Selected -----------------

  checkIfPreviousMonthSelected() {
    // console.log(this.selectedMonthForDWM);
    // const currentMonthIndex = new Date().getMonth();
    // const selectedIndex = this.monthsList.indexOf(this.selectedMonthForDWM);
    // const prevMonthIndex = currentMonthIndex === 0 ? 11 : currentMonthIndex - 1;
    // this.showCopyButton = selectedIndex === prevMonthIndex;
    // this.showAddButton = selectedIndex === prevMonthIndex;
    this.showCopyButton = this.dwmGenericServiceService.isCurrentOrPreviousMonth(this.selectedMonthForDWM);
    this.showAddOrSaveButton = this.dwmGenericServiceService.isCreateTaskEnabled(this.dwmGenericServiceService.getTodaysDateFromSelectedMonth(this.selectedMonthForDWM, this.selectedYearForDWM), this.cuttoffDetails?.getCurrentCuttOffDate);
    this.currentPageNumber = 1;
    this.getNewDWMData();
  }

  // --------------------------- Repeat toggle ----------------------------------------
  onRepeatToggle(task: any) {
    if (!task.isRepetativeTask) {
      task.dwmFrequency = null;
    }
  }

  // ---------------------------- Delete dwm -----------------------------------------
  hasSubmittedTaskSelected(): boolean {
    return this.selectedTaskList.some((t: any) => t.dwmStatus === 'Pending' || t.dwmStatus === 'Approved' || t.dwmStatus === 'Rejected');
  }

  // --------------------------------- On Month Year Change ---------------------------------------------

  onMonthYearSelectionChange() {
    this.currentPageNumber = 1;
    this.getNewDWMData();

    const isAnnual = this.selectedMonthYearDWM === 'Annually';

    // Efficient selection
    this.frequencyList = isAnnual ? this.annualFrequencyList : this.allFrequencyList;

    // Reset only if needed
    this.taskList?.forEach(task => {
      if (task?.isRepetativeTask) task.dwmFrequency = '';
    });
  }

  getMonthYearDropdown(): string[] {
    const options: string[] = ['Monthly']; // Monthly always visible

    if (this.isL4AndAboveEmployee) {
      options.push('Annually'); // Only L4+ can see Annually
    }

    return options;
  }

  // ----------------------------- Filter Employees R&D and L4_Above ----------------------
  getEmployeeList() {
    this.getCompanyAndUserData.getAllEmployeeByCompanyID().subscribe((res: any) => {
      const empList = res?.data || [];
      const loggedInEmpId = this.loggedInUserId;
      const loggedInEmployee = empList.find((emp: any) => emp.id === loggedInEmpId);
      /* ---------------- R&D Role ---------------- */
      this.isRNDEmployee = loggedInEmployee?.department === 'R&D';

      /* ---------------- L4 & Above Role ---------------- */
      this.isL4AndAboveEmployee = this.checkL4AndAbove(loggedInEmployee?.grade);

      this.frequencyList = this.isL4AndAboveEmployee ? this.allFrequencyList.filter(f => f !== 'Hourly') : [...this.allFrequencyList];

      // console.log('L4 And Above Employee:', this.isL4AndAboveEmployee);
    });
  }

  // ----------------------- Check L4 and Above Employees ---------------------
  checkL4AndAbove(grade: string | null): boolean {
    if (!grade) return false;
    const level = Number(grade.replace('L', ''));
    return level >= 4;
  }

  // --------------------------------- Edit Row ---------------------------------------------

  editRow(index: number) {
    this.taskList.forEach((task: any, i: number) => {
      if (i !== index) task.isEdit = false;
    });
    this.taskList[index].backup = JSON.parse(JSON.stringify(this.taskList[index]));
    this.taskList[index].isEdit = true;
  }

  // --------------------------------- Save Row ---------------------------------------------

  saveRow(item: any, index: number) {
    item.isEdit = false;
    delete item.backup;
  }

  // --------------------------------- Cancel Edit ---------------------------------------------

  cancelEdit(item: any, index: number) {
    if (item.backup) {
      this.taskList[index] = { ...item.backup, isEdit: false };
    }

    delete this.taskList[index].backup;
  }

  // --------------------------------- Delete Row ---------------------------------------------

  deleteRow(index: number): void {
    this.taskList.splice(index, 1);
    this.taskList = [...this.taskList];
    this.selectedTaskList = [];
    this.selectAllTaskCheckbox = false;
  }

  downloadPDFAndExcel(downloadType: 'pdf' | 'excel') {
    const source = this.allTaskList || [];
    console.log('Donwloading status..', source);
    if (!source.length) {
      this.toastr.warning('No task data available to export!');
      return;
    }

    /* ===================== EXCEL ===================== */
    if (downloadType === 'excel') {
      const excelData = source.map((task: any) => {
        return {
          Critical: task?.isCriticalTask ? 'Yes' : 'No',
          Category: this.categoryMap?.[task?.categoryId] || '',
          Actionable: task?.actionable || '',
          'Time From': task?.timeFrom || '',
          'Time To': task?.timeTo || '',
          'Repeat?': task?.isRepetativeTask ? 'Yes' : 'No',
          Frequency: task?.dwmFrequency || '',
          Date: task?.dwmDate ? this.datePipe.transform(task.dwmDate, 'longDate') : '',
          Status: task?.dwmStatus ? this.dwmGenericServiceService.getStatusLabel(task.dwmStatus) || task.dwmStatus : '',

          'Manager Comment': task?.dwmStatus === 'Rejected' ? task?.managerComments || '' : ''
        };
      });

      this.dwmGenericServiceService.saveAsExcelFile(excelData, 'My DWM Tasks', 'my_dwm_tasks');
    }

    /* ====================== PDF ====================== */
    if (downloadType === 'pdf') {
      const pdfTableHeaders: string[] = ['Critical', 'Category', 'Actionable', 'Time From', 'Time To', 'Repeat?', 'Frequency', 'Date', 'Status', 'Manager Comment'];

      const pdfTableData = source.map((task: any) => {
        return [task?.isCriticalTask ? 'Yes' : 'No', this.categoryMap?.[task?.categoryId] || '', task?.actionable || '', task?.timeFrom || '', task?.timeTo || '', task?.isRepetativeTask ? 'Yes' : 'No', task?.dwmFrequency || '', task?.dwmDate ? this.datePipe.transform(task.dwmDate, 'longDate') : '', task?.dwmStatus ? this.dwmGenericServiceService.getStatusLabel(task.dwmStatus) || task.dwmStatus : '', task?.dwmStatus === 'Rejected' ? task?.managerComments || '' : ''];
      });

      this.dwmGenericServiceService.downloadTableAsPdf(pdfTableHeaders, pdfTableData, 'My DWM Tasks', 'my_dwm_tasks');
    }
  }

  copyTask() {
    alert('Copy task clicked');
  }

  openPicker(picker: any) {
    picker.open();
  }

  // ------------------------------------------------Search Task ---------------------------------------------

  onSearchTask(searchValue: string) {
    if (!searchValue) {
      this.currentPageNumber = 1;
      this.applyPagination(); // reset pagination if search cleared
      return;
    }

    const lowerSearch = searchValue.toLowerCase();

    const filteredTasks = this.allTaskList.filter(task => {
      return task.categoryName?.toLowerCase().includes(lowerSearch) || task.actionable?.toLowerCase().includes(lowerSearch) || task.dwmFrequency?.toLowerCase().includes(lowerSearch) || task.dwmDate?.toLowerCase().includes(lowerSearch) || task.dwmStatus?.toLowerCase().includes(lowerSearch);
    });

    this.taskList = filteredTasks.slice(0, this.selectedSizeOfTask);
    this.totalTaskCount = filteredTasks.length;
    this.totalTaskPages = Math.ceil(filteredTasks.length / this.selectedSizeOfTask);
    this.showingCount = 1;
    this.showingOfCount = Math.min(this.selectedSizeOfTask, filteredTasks.length);
  }

  // ------------------------------------------------Pagination ---------------------------------------------

  onSelectSizeCount() {
    this.currentPageNumber = 1;
    this.getNewDWMData();
  }

  // ----------------------------------------------- Add New Task ---------------------------------------------

  addNewTask() {
    const newRow = {
      id: null,
      checkboxCheck: false,
      category: null,
      actionable: '',
      timeFrom: '',
      timeTo: '',
      isRepetativeTask: true,
      dwmFrequency: null,
      dwmDate: null,
      calendor: '',
      dwmStatus: null,
      isNew: true,
      isNewRow: true
    };

    this.taskList.unshift(newRow);
    this.selectedTaskList = [];
    this.selectAllTaskCheckbox = false;
  }

  // ------------------------------------------------ All Task Records ---------------------------------------------

  // selectALLTaskRecords(event: any) {
  //   if (event.checked) {
  //     this.selectedTaskList = [];
  //     this.selectAllTaskCheckbox = true;
  //     for (let i = 0; i < this.taskList.length; i++) {
  //       this.taskList[i].checkboxCheck = true;
  //       this.selectedTaskList.push(this.taskList[i]);
  //     }
  //   } else {
  //     for (let i = 0; i < this.taskList.length; i++) {
  //       this.taskList[i].checkboxCheck = false;
  //     }
  //     this.selectAllTaskCheckbox = false;
  //     this.selectedTaskList = [];
  //   }
  // }

  selectALLTaskRecords(event: any) {
    this.selectedTaskList = [];
    // console.log('this.taskList ------------- ', this.taskList);
    if (event.checked) {
      this.selectAllTaskCheckbox = true;
      if (this.showCopyButton) {
      } else {
      }

      this.taskList.forEach(task => {
        if (task.dwmStatus !== 'Approved' || this.showCopyButton) {
          task.checkboxCheck = true;
          this.selectedTaskList.push(task);
        }
      });
    } else {
      this.taskList.forEach(task => (task.checkboxCheck = false));
      this.selectAllTaskCheckbox = false;
    }
  }

  // ------------------------------------------------ Single Task Records ---------------------------------------------

  selectSingleTaskRecords(event: any, data: any, i: number) {
    if (event.checked) {
      this.taskList[i].checkboxCheck = true;
      this.selectedTaskList.push(data);
    } else {
      this.selectAllTaskCheckbox = false;
      this.taskList[i].checkboxCheck = false;
      this.selectedTaskList.forEach((ele: any, ind: any) => {
        if (ele.checkboxCheck == false) {
          this.selectedTaskList.splice(ind, 1);
        }
      });
    }
  }

  // ------------------------------------------------ Sort Ascending ---------------------------------------------
//--------------------------------------- Sort Ascending ---------------------------------------------
onSortAssending(col: string) {
  this.sortTable(col, true);
}

onSortDesending(col: string) {
  this.sortTable(col, false);
}

sortTable(col: string, asc: boolean) {
  const map: any = {
    'Critical': 'isCriticalTask',
    'Category': 'categoryId', 
    'Actionable': 'actionable',
    'Time From': 'timeFrom',
    'Time To': 'timeTo',
    'Repeat?': 'isRepetativeTask',
    'Frequency': 'dwmFrequency',
    'Date': 'dwmDate',
    'Status': 'dwmStatus',
    'Manager Comment': 'managerComments'
  };

  const key = map[col];

  this.allTaskList.sort((a: any, b: any) => {
    let x = a[key];
    let y = b[key];

    // Handle null/undefined
    x = x ?? '';
    y = y ?? '';

    // Boolean handling
    if (typeof x === 'boolean' && typeof y === 'boolean') {
      return asc ? Number(x) - Number(y) : Number(y) - Number(x);
    }

    // Date handling
    if (key === 'dwmDate') {
      const d1 = x ? new Date(x).getTime() : 0;
      const d2 = y ? new Date(y).getTime() : 0;
      return asc ? d1 - d2 : d2 - d1;
    }

    // Default string/number compare
    return asc
      ? String(x).localeCompare(String(y), undefined, { numeric: true, sensitivity: 'base' })
      : String(y).localeCompare(String(x), undefined, { numeric: true, sensitivity: 'base' });
  });

  this.applyPagination();
}

  // --------------------------------------------  Validation for the character -------------------------------------

  toastShown = false;

  checkMaxLength(comment: string) {
    if (comment?.length === 500 && !this.toastShown) {
      this.toastShown = true;

      this.toastr.error('Maximum limit is 500 characters', 'Limit Reached');

      setTimeout(() => {
        this.toastShown = false;
      }, 3000);
    }
  }
  // ------------------------------------------------ previous Page Task ---------------------------------------------

  previousPageTask() {
    if (this.currentPageNumber > 1) {
      this.currentPageNumber--;
      this.getNewDWMData();
    }
  }

  nextPageTask() {
    if (this.currentPageNumber < this.totalTaskPages) {
      this.currentPageNumber++;
      this.getNewDWMData();
    }
  }

  // ------------------------------------------------ Get DWM Category List ---------------------------------------------
  categoryMap: { [key: number]: string } = {};

  getDWMCatwegoryList() {
    this.httpService.callGetService(`${this.config.getCategoriesList}?companyId=${this.loggedInUserCompanyID}`).subscribe((data: any) => {
      this.categoryList = (data?.data || [])
        .filter((item: any) => item.categoryName.trim() !== 'R&D')
        .map((item: any) => ({
          ...item,
          id: item.categoryId
        }))
        .reverse();
      /*  BUILD CATEGORY MAP (ID → NAME) */
      this.categoryMap = {};
      this.categoryList.forEach((cat: any) => {
        this.categoryMap[cat.categoryId] = cat.categoryName;
      });
    });
    // console.log('Filtered Categories List:', this.categoryList);
  }

  // ----------------------------------------------- Format Frequency  ---------------------------------------------
  formatFrequency(value: string): string {
    if (!value) return value;
    return value
      .toLowerCase()
      .replace(/_/g, '-')
      .replace(/\b\w/g, c => c.toUpperCase());
  }

  // ------------------------------------------ Format Status --------------------------------------------------

  formatStatus(status: string): string {
    return status
      .replace(/_/g, ' ')
      .toLowerCase()
      .replace(/\b\w/g, c => c.toUpperCase());
  }

  // ------------------------------------------------ Get New DWM Data ---------------------------------------------

  allTaskList: any[] = []; // store full filtered tasks for search
  private resolveDwmYearForUI(): number {
    if (this.selectedMonthYearDWM === 'Monthly') {
      return this.getDwmYear(); // existing logic
    } else if (this.selectedMonthYearDWM === 'Annually') {
      const yearParts = this.selectedYearForDWM.split('-');
      return Number(yearParts[1]);
    }
    return Number(this.selectedYearForDWM);
  }

  // getNewDWMData(): void {
  //   // ------------------ Month Number Calculation ------------------
  //   const monthNumber = this.selectedMonthForDWM && this.selectedMonthYearDWM !== 'Annually' ? this.monthsList.indexOf(this.selectedMonthForDWM) + 1 : null;

  //   // ------------------ Extract Selected Year (IMPORTANT FIX) ------------------
  //   // const selectedYear = this.selectedYearForDWM?.includes('-')? this.selectedYearForDWM.split('-')[0]
  //   //   : this.selectedYearForDWM;
  //   const selectedYear = this.resolveDwmYearForUI();

  //   // ------------------ API Call ------------------
  //   this.httpService.callGetService(`${this.config.getDwmMaster}?companyId=${this.loggedInUserCompanyID}`).subscribe((response: any) => {
  //     let allTasks = response?.data || [];

  //     // ------------------ FILTER BY LOGGED-IN USER ------------------
  //     const loggedUserId = Number(this.loggedInUserId);

  //     allTasks = allTasks.filter((t: any) => Number(t.userId) === loggedUserId);

  //     // ------------------ FILTER BY TYPE / MONTH / YEAR ------------------
  //     if (this.selectedMonthYearDWM === 'Monthly') {
  //       allTasks = allTasks.filter((t: any) => t.dwmType === 'Monthly' && Number(t.dwmMonth) === Number(monthNumber) && String(t.dwmYear) === String(selectedYear));
  //     } else if (this.selectedMonthYearDWM === 'Annually') {
  //       allTasks = allTasks.filter((t: any) => t.dwmType === 'Annually' && String(t.dwmYear) === String(selectedYear));
  //     }

  //     allTasks = allTasks.map((task: any) => ({
  //       ...task,
  //       dwmFrequency: this.formatFrequency(task.dwmFrequency)
  //     }));

  //     this.allTaskList = [...allTasks];
  //     this.applyPagination();
  //   });
  // }

   getNewDWMData(): void {
    const selectedMonthNumber = this.selectedMonthForDWM && this.selectedMonthYearDWM !== 'Annually' ? this.monthsList.indexOf(this.selectedMonthForDWM) + 1 : null;

    const selectedYear = this.resolveDwmYearForUI();

    this.httpService.callGetService(`${this.config.getDwmMaster}?companyId=${this.loggedInUserCompanyID}`).subscribe((response: any) => {
      let allTasks = response?.data || [];

      // Logged-in user filter
      const loggedUserId = Number(this.loggedInUserId);
      allTasks = allTasks.filter((t: any) => Number(t.userId) === loggedUserId);

      //  MONTH FILTER USING dwmDate (FINAL FIX)
      if (this.selectedMonthYearDWM === 'Monthly') {
        allTasks = allTasks.filter((t: any) => {
          if (!t.dwmDate) return false;

          const taskDate = new Date(t.dwmDate);
          const taskMonth = taskDate.getMonth() + 1;
          const taskYear = taskDate.getFullYear();

          return t.dwmType === 'Monthly' && taskMonth === selectedMonthNumber && String(taskYear) === String(selectedYear);
        });
      // } else if (this.selectedMonthYearDWM === 'Annually') {
      //   allTasks = allTasks.filter((t: any) => {
      //     if (!t.dwmDate) return false;
      //     const taskYear = new Date(t.dwmDate).getFullYear();
      //     return t.dwmType === 'Annually' && String(taskYear) === String(selectedYear);
      //   });
      // }

      } else if (this.selectedMonthYearDWM === 'Annually') {
  allTasks = allTasks.filter((t: any) => {
    if (!t.dwmDate) return false;

    const taskDate = new Date(t.dwmDate);
    const taskFiscalYear = this.getFiscalYearFromDate(taskDate);

    return t.dwmType === 'Annually' &&
           taskFiscalYear === this.selectedYearForDWM;
  });
}
      // Keep existing formatting
      allTasks = allTasks.map((task: any) => ({
        ...task,
        dwmFrequency: this.formatFrequency(task.dwmFrequency)
        // isEdit: task.dwmStatus === 'Draft',
        // isNewRow: false
      }));

      this.allTaskList = [...allTasks];
      this.applyPagination();
    });
  }


  getFiscalYearFromDate(date: Date): string {
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // Jan = 1

  if (month >= 4) {
    // April → Dec
    return `${year}-${year + 1}`;
  } else {
    // Jan → March
    return `${year - 1}-${year}`;
  }
}

  applyPagination() {
    // Reset checkbox state
    this.allTaskList.forEach((task: any) => (task.checkboxCheck = false));
    this.selectAllTaskCheckbox = false;
    this.selectedTaskList = [];

    this.totalTaskCount = this.allTaskList.length;
    this.totalTaskPages = Math.ceil(this.totalTaskCount / this.selectedSizeOfTask);

    const startIndex = (this.currentPageNumber - 1) * this.selectedSizeOfTask;
    const endIndex = startIndex + this.selectedSizeOfTask;

    this.showingCount = startIndex + 1;
    this.showingOfCount = Math.min(endIndex, this.totalTaskCount);

    // Assign only the current page to taskList
    this.taskList = this.allTaskList.slice(startIndex, endIndex);
  }

  //  -------------------------------------------------Format Time  ---------------------------------------------

  formatTime(value: string): string {
    if (!value) return '';
    if (/^\d{2}:\d{2}$/.test(value)) return value;
    if (/^\d{2}:\d{2}:\d{2}$/.test(value)) return value;
    const parts = value.split(':');
    return `${parts[0]}:${parts[1]}`;
  }

  // ------------------------------------------------ Validate Time ---------------------------------------------

  checkTime(item: any): void {
    item.timeError = item.timeFrom && item.timeTo && item.timeFrom >= item.timeTo;
  }

  //  ------------------------------------------------ Format Date ---------------------------------------------

  formatDate(date: any): string {
    if (!date) return '';
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${d.getFullYear()}-${month}-${day}`;
  }

  // ----------------------------------------------- Save Task ---------------------------------------------
  private resolveUserManagerIds() {
    const roles = this.loggedInUserRoles || [];

    const isManagerOrHOD = roles.some((r: any) => r.displayName === 'Manager' || r.displayName === 'HOD');

    // 🚨 IMPORTANT: Manager/HOD OVERRIDES Employee
    if (isManagerOrHOD) {
      return {
        userId: null,
        managerId: Number(this.loggedInUserId)
      };
    }

    // Only Employee
    return {
      userId: Number(this.loggedInUserId),
      managerId: null
    };
  }

  saveTask(): void {
    const tasksToSave = this.taskList.filter(t => t.isNew === true);

    if (!tasksToSave.length) {
      this.toastr.warning('No new task to save');
      return;
    }

    // Category & Actionable validation
    const invalidTask = tasksToSave.find(t => !t.categoryId || !t.actionable || t.actionable.trim().length === 0 || !t.dwmDate);
    if (invalidTask) {
      this.toastr.error('Category and Actionable and Date are mandatory');
      return;
    }

    if (tasksToSave.some(t => t.isNew && t.timeError)) {
      this.toastr.error('From Time must be less than To Time');
      return;
    }

    // console.log('Manager/HOD rol............', this.loggedInUserRole);
    const monthNumber = this.selectedIsAnnual ? null : this.monthsList.indexOf(this.selectedMonthForDWM) + 1;
    const { userId, managerId } = this.resolveUserManagerIds();
    const payload = tasksToSave.map(task => ({
      id: null,
      dwmType: this.selectedMonthYearDWM,
      dwmStatus: null,
      dwmFrequency: task.dwmFrequency?.toUpperCase()?.replace('-', '_'),
      userId: Number(this.loggedInUserId),
      managerId: this.loggedInUserRole == 'Employee' ? task.managerId : this.loggedInUserId,
      companyId: this.loggedInUserCompanyID,
      categoryId: task.categoryId,
      dwmYear: this.getDwmYear(),
      fiscalYear: this.loggedInCompanyFiscalyear,
      dwmMonth: monthNumber,
      dwmDate: task.dwmDate ? this.formatDate(task.dwmDate) : null,
      timeFrom: this.formatTime(task.timeFrom),
      timeTo: this.formatTime(task.timeTo),
      actionable: task.actionable,
      isRepetativeTask: task.isRepetativeTask ?? false,
      empComments: task.empComments ?? null,
      isCriticalTask: task.isCriticalTask ?? false,
      dwmActive: true
    }));

    this.saveApiCall(payload, 'Saved as Draft');
  }

  saveApiCall(payload: any, successMessage = 'Saved as Draft') {
    this.httpService.callPostService(this.config.saveOrUpdateMaster, payload).subscribe({
      next: (res: any) => {
        this.toastr.success(successMessage, 'Success');
        this.getNewDWMData();
      },
      error: (err: any) => {
        const errorMsg = err?.error?.message || 'Save failed';
        this.toastr.warning(errorMsg, 'Warning');
      }
    });
  }
  saveApiCallCopy(payload: any, successMessage = 'Saved as Draft') {
    this.httpService.callPostService(this.config.copyTask, payload).subscribe({
      next: (res: any) => {
        this.toastr.success(successMessage, 'Success');
        this.getNewDWMData();
      },
      error: (err: any) => {
        const errorMsg = err?.error?.message || 'Save failed';
        this.toastr.warning(errorMsg, 'Warning');
      }
    });
  }

  getDwmYear(): number {
    if (!this.selectedMonthForDWM || !this.filteredMonthsList?.length) {
      return Number(this.selectedYearForDWM.split('-')[0]);
    }

    const [startYear, endYear] = this.selectedYearForDWM.split('-').map(Number);
    const fiscalStartMonth = this.filteredMonthsList[0];

    return this.monthsList.indexOf(this.selectedMonthForDWM) < this.monthsList.indexOf(fiscalStartMonth) ? endYear : startYear;
  }

  // ------------------------------------------------ Submit For Approval ---------------------------------------------

  submitForApproval(): void {
    // const validTasks = this.selectedTaskList.filter((task: { dwmStatus: string }) => task.dwmStatus !== 'Approved');
    // FIXED - only allows Draft and Rejected
const validTasks = this.selectedTaskList.filter((task: any) => 
  task.dwmStatus === 'Draft' || task.dwmStatus === 'Rejected' || task.dwmStatus === null
);

    // if (!validTasks.length) {
    //   this.toastr.warning('No valid tasks to submit');
    //   return;
    // }
  if (!validTasks.length) {
    this.toastr.warning('Only Draft or Rejected tasks can be submitted for approval');
    return;
  }
    if (!this.selectedTaskList.length) {
      this.toastr.warning('Please select at least one task');
      return;
    }

    // const hasInvalidRow = this.selectedTaskList
    //   .filter((t: any) => !t.dwmStatus) // ONLY draft rows
    //   .some((t: any) => !t.categoryId || !t.actionable?.trim() || !t.dwmDate || (!this.selectedIsAnnual && !(this.isL4AndAboveEmployee && this.selectedMonthYearDWM === 'Monthly') ) || (t.isRepetativeTask && !t.dwmFrequency));

    // if (hasInvalidRow) {
    //   this.toastr.error('Please fill all mandatory fields before submitting');
    //   return;
    // }

    const hasUnsavedTask = this.selectedTaskList?.some((t: any) => t.isNewRow || t.isEdit);

    if (hasUnsavedTask) {
      this.toastr.error('Please save task before submit');
      return;
    }
    const monthNumber = this.selectedIsAnnual ? null : this.monthsList.indexOf(this.selectedMonthForDWM) + 1;

    // console.log('Logged in user ID:', this.loggedInUserId);
    const { userId, managerId } = this.resolveUserManagerIds();
    const payload = validTasks.map((task: any) => ({
      id: task.id ?? null,
      dwmType: this.selectedMonthYearDWM,
      dwmStatus: 'Pending',
      dwmFrequency: task.dwmFrequency?.toUpperCase()?.replace('-', '_'),
      userId: Number(this.loggedInUserId),
      managerId: this.loggedInUserRole == 'Employee' ? task.managerId : this.loggedInUserId,
      companyId: this.loggedInUserCompanyID,
      // categoryId: task?.category?.categoryId || task?.category,
         categoryId: task.categoryId,
      // dwmYear: this.selectedYearForDWM.split('-')[0],
      dwmYear: this.getDwmYear(),
      fiscalYear: this.loggedInCompanyFiscalyear,
      dwmMonth: monthNumber,
      dwmDate: task.dwmDate ? this.formatDate(task.dwmDate) : null,
      timeFrom: this.formatTime(task.timeFrom),
      timeTo: this.formatTime(task.timeTo),
      actionable: task.actionable,
      isRepetativeTask: task.isRepetativeTask ?? false,
      empComments: task.empComments ?? null,
      isCriticalTask: task.isCriticalTask ?? false,
      dwmActive: true
    }));

    this.httpService.callPostService(this.config.saveOrUpdateMaster, payload).subscribe({
      next: () => {
        this.toastr.success('Submitted for approval');
        this.getNewDWMData();
        this.selectedTaskList = [];
        this.selectAllTaskCheckbox = false;
      },
      error: () => {
        this.toastr.error('Submission failed');
      }
    });
  }

  // ------------------------------------------------ Delete Records ---------------------------------------------

  // onClickDeleteRecord() {
  //   const selectedTaskIds = this.selectedTaskList
  //   .filter((t: any) => t.checkboxCheck === true && t.id)
  //   .map((t: any) => t.id);

  //   if (selectedTaskIds.length === 0) {
  //     this.toastr.warning("Please select at least one task");
  //     return;
  //   }

  //   const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
  //     disableClose: true,
  //     height: '25%',
  //     width: '30%',
  //     data: {
  //       msg: 'Are you sure you want to delete?',
  //       btn1: 'Cancel',
  //       btn2: 'Delete',
  //       btn2BgColor: this.buttonColorName,
  //     },
  //   });

  //   dialogRef.afterClosed().subscribe((result) => {
  //     if (result) {
  //       const taskIds = selectedTaskIds.join(',');
  //       this.httpService
  //       .callDeleteService(`${this.config.deleteDwmMaster}?id=${taskIds}`)
  //       .subscribe(() => {
  //         this.toastr.success('Deleted successfully', 'Success');
  //         this.getNewDWMData();
  //       });
  //     }
  //   });
  // }

  onClickDeleteRecord(): void {
    const selectedTaskIds = this.selectedTaskList.filter((t: any) => t.checkboxCheck === true && t.id).map((t: any) => t.id);

    if (selectedTaskIds.length === 0) {
      this.toastr.warning('Please select at least one task');
      return;
    }

    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      maxWidth: '450px',
      panelClass: ['phi_mdc_dialog__container_100_phi_mdc_dialog__content_85_vh'],
      data: {
        msg: 'Are you sure you want to delete?',
        btn1: 'Cancel',
        btn2: 'Delete',
        btn2BgColor: this.buttonColorName
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const payload = {
          ids: selectedTaskIds,
          companyId: this.loggedInUserCompanyID
        };
        this.httpService.callPostService(this.config.deleteDwmMaster, payload).subscribe({
          next: (res: any) => {
            this.toastr.success(res.message, 'Success');
            this.getNewDWMData();
          },
          error: () => {
            this.toastr.error('Delete failed');
          }
        });
      }
    });
  }

  // --------------------------------- Update DWM Task -------------------------------------------- 2-

  updateDWM(index: number): void {
    const item = this.taskList[index];
    // ------------------ Mandatory Field Validation ------------------
    if (!item.categoryId || !item.actionable || item.actionable.trim().length === 0 || !item.dwmDate) {
      this.toastr.error('Category and Actionable and Date are mandatory');
      return;
    }

    // ------------------ Time Validation ------------------
    if (item.timeError) {
      this.toastr.error('From Time must be less than To Time');
      return;
    }

    // ------------------ Extract Year ------------------
    const dwmYear = this.selectedYearForDWM?.includes('-') ? this.selectedYearForDWM.split('-')[0] : this.selectedYearForDWM;
    const { userId, managerId } = this.resolveUserManagerIds();
    // ------------------ Build Payload ------------------
    const payload = [
      {
        id: item.id,
        dwmType: item.dwmType || this.selectedMonthYearDWM,
        dwmStatus: item.dwmStatus,
        dwmFrequency: item.dwmFrequency?.toUpperCase(),
        userId: Number(this.loggedInUserId),
        managerId: this.loggedInUserRole == 'Employee' ? item.managerId : this.loggedInUserId,
        companyId: this.loggedInUserCompanyID,
        categoryId: item.categoryId,
        // dwmYear: dwmYear,
        dwmYear: this.getDwmYear(),
        fiscalYear: this.loggedInCompanyFiscalyear,
        dwmMonth: item.dwmMonth,
        dwmDate: item.dwmDate ? this.formatDate(item.dwmDate) : null,
        timeFrom: this.formatTime(item.timeFrom),
        timeTo: this.formatTime(item.timeTo),
        actionable: item.actionable,
        isRepetativeTask: item.isRepetativeTask,
        empComments: item.empComments,
        managerComments: item.managerComments,
        isCriticalTask: item.isCriticalTask,
        dwmActive: true
      }
    ];

    // console.log('UPDATE PAYLOAD:', payload);

    // ------------------ API Call ------------------
    this.httpService.callPostService(this.config.saveOrUpdateMaster, payload).subscribe({
      next: (res: any) => {
        this.toastr.success('Task updated successfully');

        // exit edit mode
        item.isEdit = false;

        // refresh list (recommended)
        this.getNewDWMData();
      },
      error: (err: any) => {
        const errorMsg = err?.error?.message || 'Save failed';
        this.toastr.warning(errorMsg, 'Warning');
      }
    });
  }

  // ------------------------------------------------ Copy Previous Month Task ------------------------------------

  // open copy previous month popup
  openCopyPreviousMonthPopup() {
    // console.log('this.selectedTaskList -------------- ', this.selectedTaskList);
    // console.log('this.taskList -------------- ', this.taskList);
    if (!this.selectedTaskList.length) {
      this.toastr.warning('Please select at least one task to copy', 'Warning');
      return;
    }

    // const selectedTasks = this.taskList.filter((task: any) => task.isSelected); // single or all checkbox

    // console.log('selectedTasks ---------------- ', selectedTasks);
    // if (!selectedTasks.length) {
    //   this.toastr.warning('Please select at least one task to copy', 'Warning');
    //   return;
    // }

    const dialogRef = this.dialog.open(CopypreviousmonthpopupComponent, {
      maxWidth: '767px',
      panelClass: ['phi_mdc_dialog__container_100_phi_mdc_dialog__content_85_vh'],
      data: {
        selectedTasks: this.selectedTaskList
      }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      // console.log(result);
      if (result?.length) {
        // this.allTaskList = [...this.allTaskList, ...result.copiedTasks];

        // hide Submit button for copied tasks
        // this.showSubmitButton = false;

        this.saveApiCallCopy(result, 'Tasks copied successfully');
        // this.toastr.success('Tasks copied successfully', 'Success');

        // refresh table/pagination
        // this.applyPagination();
      }
    });
  }

  allDwmTasks: any[] = [];

  copyPreviousMonthTasks(sourceMonth: number, sourceYear: number, targetMonth: number, targetYear: number) {
    // FILTER PREVIOUS MONTH TASKS
    const previousMonthTasks = this.allDwmTasks.filter((task: any) => task.dwmType === 'Monthly' && Number(task.dwmMonth) === sourceMonth && Number(task.dwmYear) === sourceYear);

    if (!previousMonthTasks.length) {
      this.toastr.error('No tasks found in previous month', 'Close');
      return;
    }

    // CLONE TASKS
    const copiedTasks = previousMonthTasks.map((task: any) => ({
      ...task,
      id: null,
      dwmMonth: targetMonth,
      dwmYear: targetYear,
      status: 'DRAFT',
      isNew: true,
      isEdit: true,
      checkboxCheck: false
    }));

    // UPDATE CURRENT VIEW
    this.taskList = copiedTasks;

    this.selectedMonthForDWM = this.monthsList[targetMonth - 1];
    this.selectedYearForDWM = `${targetYear}`;

    this.totalTaskCount = copiedTasks.length;
    this.showingOfCount = copiedTasks.length;

    // console.log('Copied Tasks:', this.taskList);
  }

  // copyPreviousMonthTask() {
  //   const dialogRef = this.dialog.open(CopypreviousmonthpopupComponent, {
  //     // width: '390px',
  //      maxWidth:'500px',
  //     panelClass: ['phi_mdc_dialog__container_100_phi_mdc_dialog__content_85_vh'],
  //    data: {
  //     tasksToCopy: this.taskList
  //   }
  //   });
  //      dialogRef.afterClosed().subscribe(result => {
  //     if (result?.success) {
  //     this.taskList = [...this.taskList, ...result.copiedTasks];
  //     this.toastr.success("Tasks copied successfully!");
  //     }
  //   });
  // }

  // ------------------------------------------------  Annual Selected ----------------------------------------

  get selectedIsAnnual(): boolean {
    return this.selectedMonthYearDWM === 'Annually';
  }

  // -------------------------------- Toggle Download Button ---------------------------------------------

  toggleDownloadBtnFn() {
    this.toggleDownloadBtn = !this.toggleDownloadBtn;
  }

  // ------------------ Export to PDF --------------------------

  exportTableToPDF(): void {}

  // ------------------- Export to Excel --------------------------

  exportToExcel(): void {
    if (!this.taskList || this.taskList.length === 0) {
      this.toastr.warning('No task data to export!');
      return;
    }
    const data = this.taskList.map(task => {
      return {
        Category: task.categoryId || '',
        Actionable: task.actionable || '',
        'Time From': task.timeFrom || '',
        'Time To': task.timeTo || '',
        'Repetitive Task': task.isRepetativeTask ? 'Yes' : 'No',
        Frequency: task.dwmFrequency || '',
        Date: task.dwmDate ? this.datePipe.transform(task.dwmDate, 'dd/MM/yyyy') : '',
        Status: task.status || 'Pending'
      };
    });

    // Create worksheet and workbook
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'DWM Tasks');
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    });
    this.saveAsExcelFile(excelBuffer, `DWM_Tasks`);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: 'application/octet-stream' });
    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleDateString('en-GB').replace(/\//g, '-'); // dd-mm-yyyy
    saveAs(data, `${fileName}-${formattedDate}.xlsx`);
  }
}
